import { inputAnatomy } from '@chakra-ui/anatomy'
import { createMultiStyleConfigHelpers } from '@chakra-ui/react'

const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(inputAnatomy.keys)

const brand = definePartsStyle({
  // define the part you're going to style
  field: {
    // fontFamily: 'mono', // change the font family
    color: 'white',
    bg: 'brand.900', // change the input text color
    border: '1px solid',
    borderColor: 'outline', // change the border color
    borderRadius: 0,
  },
  addon: {
    bg: 'brand.900', // change the input text color
    border: '1px solid',
    borderColor: 'outline', // change the border color
    borderRadius: 0,
  },
})

export const inputTheme = defineMultiStyleConfig({
  variants: { brand },
  baseStyle: {
    field: {
      border: '1px solid',
      borderColor: 'blackAlpha.300', // change the border color
      _disabled: {
        backgroundColor: 'hsl(0, 0%, 95%)',
        opacity: 1,
        color: 'hsl(0, 0%, 50%)',
        cursor: 'pointer',
      },
    },
  },
})
